import nextId from '../../utils/nextId';
import {
  ADDED,
  DELETED,
  FILTERED,
  IDADDED,
  LOADED,
  SEARCHED,
  UPDATED,
} from './actionTypes';
import initialState from './initialState';

const bookReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADED:
      return {
        ...state,
        items: action.payload,
      };

    case ADDED:
      return {
        ...state,
        items: [
          ...state.items,
          {
            id: nextId(state.items),
            ...action.payload,
          },
        ],
      };

    case UPDATED:
      return {
        ...state,
        items: state.items.map((book) => {
          if (book.id === action.payload.id) {
            return action.payload;
          }

          return book;
        }),
      };

    case IDADDED:
      return {
        ...state,
        bookToUpdate: action.payload,
      };

    case DELETED:
      return {
        ...state,
        items: state.items.filter((book) => book.id !== action.payload),
      };

    case FILTERED:
      return {
        ...state,
        categoryValue: action.payload,
      };

    case SEARCHED:
      return {
        ...state,
        searchValue: action.payload,
      };
    default:
      return state;
  }
};

export default bookReducer;
